var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { DraggableCore } from 'react-draggable';
import Separador from './separador';
import Boton from './boton';
import BotonLapiz from './boton-lapiz';
import * as HERRAMIENTA from './constantes';
import BotonMarcador from './boton-marcador';
import BotonBorrador from './boton-borrador';
import BotonPulsador from './boton-pulsador';
var BarraHerramientas = (_temp = _class = function (_Component) {
  _inherits(BarraHerramientas, _Component);

  BarraHerramientas.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState) {
      return {
        x: nextProps.x,
        y: nextProps.y,
        herramientaIdSeleccionado: nextProps.herramientaIdSeleccionado
      };
    }

    if (nextProps.herramientaIdSeleccionado !== prevState.herramientaIdSeleccionado) {
      return {
        herramientaIdSeleccionado: nextProps.herramientaIdSeleccionado
      };
    }

    return null;
  };

  function BarraHerramientas(props) {
    _classCallCheck(this, BarraHerramientas);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleDrag = function (e, data) {
      _this.setState(function (prevState) {
        var bounds = document.body.getBoundingClientRect();
        var x = prevState.x + data.deltaX;
        var y = prevState.y + data.deltaY;

        if (x < 0) {
          x = 0;
        }

        if (x > bounds.width - 30) {
          x = bounds.width - 30;
        }

        if (y < 0) {
          y = 0;
        }

        if (y > bounds.height - 30) {
          y = bounds.height - 30;
        }

        return {
          x: x,
          y: y
        };
      });
    };

    _this.handlePresionado = function (herramientaId, grupo, valor) {
      _this.setState({
        herramientaIdSeleccionado: herramientaId
      }, _this.props.onPresionado(herramientaId, grupo, valor));
    };

    _this.handlePresionadoBotonNoSeleccionable = function (herramientaId, grupo, valor) {
      _this.props.onPresionado(herramientaId, grupo, valor);
    };

    _this.state = BarraHerramientas.getDerivedStateFromProps(props);
    return _this;
  }

  BarraHerramientas.prototype.renderBotones = function renderBotones() {
    var _this2 = this;

    var herramientaIdSeleccionado = this.state.herramientaIdSeleccionado;
    var _props = this.props,
        botones = _props.botones,
        grosorLapiz = _props.grosorLapiz,
        colorLapiz = _props.colorLapiz,
        grosorMarcador = _props.grosorMarcador,
        colorMarcador = _props.colorMarcador,
        grosorBorrador = _props.grosorBorrador,
        mascarasActivas = _props.mascarasActivas,
        cartulinaActiva = _props.cartulinaActiva,
        mostrarActivo = _props.mostrarActivo;
    return botones.map(function (boton, index) {
      switch (boton.id) {
        case HERRAMIENTA.SEPARADOR_ID:
          return React.createElement(Separador, {
            key: 'separador' + index
          });

        case HERRAMIENTA.LAPIZ_ID:
          return React.createElement(BotonLapiz, {
            key: boton.id,
            colores: boton.colores,
            colorSeleccionado: colorLapiz,
            grosores: boton.grosores,
            grosorSeleccionado: grosorLapiz,
            seleccionado: [HERRAMIENTA.LAPIZ_ID, HERRAMIENTA.LAPIZ_COLOR_ID, HERRAMIENTA.LAPIZ_GROSOR_ID].indexOf(herramientaIdSeleccionado) !== -1,
            onPresionado: _this2.handlePresionado
          });

        case HERRAMIENTA.MARCADOR_ID:
          return React.createElement(BotonMarcador, {
            key: boton.id,
            colores: boton.colores,
            colorSeleccionado: colorMarcador,
            grosores: boton.grosores,
            grosorSeleccionado: grosorMarcador,
            seleccionado: [HERRAMIENTA.MARCADOR_ID, HERRAMIENTA.MARCADOR_COLOR_ID, HERRAMIENTA.MARCADOR_GROSOR_ID].indexOf(herramientaIdSeleccionado) !== -1,
            onPresionado: _this2.handlePresionado
          });

        case HERRAMIENTA.BORRADOR_ID:
          return React.createElement(BotonBorrador, {
            key: boton.id,
            grosores: boton.grosores,
            grosorSeleccionado: grosorBorrador,
            seleccionado: [HERRAMIENTA.BORRADOR_ID, HERRAMIENTA.BORRADOR_GROSOR_ID].indexOf(herramientaIdSeleccionado) !== -1,
            onPresionado: _this2.handlePresionado
          });

        case HERRAMIENTA.MOSTRAR_ID:
          return React.createElement(BotonPulsador, _extends({
            key: boton.id
          }, boton, {
            herramientaId: boton.id,
            presionado: mostrarActivo,
            onPresionado: _this2.handlePresionadoBotonNoSeleccionable
          }));

        case HERRAMIENTA.ENMASCARAR_ID:
          return React.createElement(BotonPulsador, _extends({
            key: boton.id
          }, boton, {
            herramientaId: boton.id,
            presionado: mascarasActivas,
            onPresionado: _this2.handlePresionado
          }));

        case HERRAMIENTA.FOCO_ID:
          return React.createElement(BotonPulsador, _extends({
            key: boton.id
          }, boton, {
            herramientaId: boton.id,
            presionado: cartulinaActiva,
            onPresionado: _this2.handlePresionado
          }));

        default:
          return React.createElement(Boton, _extends({
            key: boton.id
          }, boton, {
            herramientaId: boton.id,
            presionado: boton.id === herramientaIdSeleccionado,
            onPresionado: _this2.handlePresionado
          }));
      }
    });
  };

  BarraHerramientas.prototype.render = function render() {
    var _props2 = this.props,
        onOcultar = _props2.onOcultar,
        visible = _props2.visible;
    var _state = this.state,
        x = _state.x,
        y = _state.y;
    var clases = ['barraHerramientas', visible ? 'abierta' : 'cerrada'].join(' ');
    return React.createElement(DraggableCore, {
      handle: '.arrastreBarraHerramientas',
      onDrag: this.handleDrag
    }, React.createElement('div', {
      className: clases,
      style: {
        left: x,
        top: y
      }
    }, React.createElement('div', {
      className: 'arrastreBarraHerramientas'
    }), React.createElement('div', {
      className: 'cerrarBarraHerramientas',
      onClick: onOcultar
    }, 'x'), this.renderBotones()));
  };

  return BarraHerramientas;
}(Component), _class.defaultProps = {
  herramientaIdSeleccionado: HERRAMIENTA.PUNTERO_ID
}, _temp);
BarraHerramientas.propTypes = process.env.NODE_ENV !== "production" ? {
  /** posicion x inicial */
  x: t.number,

  /** posicion y inicial */
  y: t.number,

  /** id herramienta seleccionada */
  herramientaIdSeleccionado: t.string,
  botones: t.array,
  visible: t.bool,
  grosorLapiz: t.number,
  colorLapiz: t.string,
  grosorMarcador: t.number,
  colorMarcador: t.string,
  grosorBorrador: t.number,
  mascarasActivas: t.bool,
  cartulinaActiva: t.bool,
  mostrarActivo: t.bool,

  /** 
   * evento que se ejecuta al pinchar el boton cerrar.
   * Es de la forma: () => {...}
   */
  onOcultar: t.func,

  /** 
   * evento que se ejecuta al pinchar cada boton de la barra.
   * Es de la forma: (herramientaId, grupo, valor) => {...}
   */
  onPresionado: t.func
} : {};
export default BarraHerramientas;